import { ModelBase } from 'store/model-base';

export class CmsAdditionalDevicePayment extends ModelBase {
    public static storeName: string = 'cmsAdditionalDevicePayment';

    public review: CmsAdditionalDevicePaymentReview;
    public result: CmsAdditionalDevicePaymentResult;
    public warning: CmsAdditionalDevicePaymentWarning;
    public header: string;
    public summary: CmsAdditionalDevicePaymentSummary;
    public start: CmsAdditionalDevicePaymentStart;
    public cancelBtn: string;
    public reviewPaymentBtn: string;
}
